import React from 'react';
import cn from 'classnames';
import { Icon } from 'react-feather';

const Banner = ({
  Icon,
  children,
  alert,
  small,
  fullWidth,
  onIconClick,
  iconColor,
  neutral,
  center,
  paleEggplant,
}: {
  Icon: Icon;
  children: React.ReactNode;
  alert: boolean;
  small: boolean;
  fullWidth: boolean;
  onIconClick: () => void;
  iconColor: string;
  neutral: boolean;
  center: boolean;
  paleEggplant: boolean;
}) => {
  // Use classnames for banner container
  const bannerClassName = cn(
    'select-none', // Base styles that always apply
    'box-border',
    'flex',
    'p-4',
    'items-center',
    {
      // Conditional styles based on props
      rounded: !fullWidth,
      'max-w-[1080px]': !fullWidth,
      'mx-auto': !fullWidth,
      'my-4': !fullWidth,
      'text-sm leading-tight': small,
      'bg-beeswax': alert,
      'bg-white border border-darkIce rounded-md': neutral,
      'bg-paleEggplant': paleEggplant,
      'max-w-full w-full m-0 rounded-none': fullWidth,
      'justify-center': center,
      'bg-babyBlue': !alert && !neutral && !paleEggplant,
    },
  );

  // Use classnames for icon container
  const iconContainerClassName = cn('mr-1', 'flex', 'items-center', {
    'cursor-pointer': onIconClick,
  });

  // Determine icon text color class (ensure iconColor value is handled)
  const iconTextColorClass = iconColor
    ? `text-${iconColor.replace('#', '')}` // Use provided color if available
    : 'text-charcoal'; // Default to charcoal

  return (
    <div className={bannerClassName}>
      {Icon && (
        <i onClick={onIconClick} className={iconContainerClassName}>
          <Icon size={16} className={iconTextColorClass} />
        </i>
      )}
      {children}
    </div>
  );
};

export default Banner;
